import { useState } from "preact/hooks";
import { useDispatch } from "react-redux";

import tracking from "../tracking/tracking";
import talentsApi from "../api/talents.js";
import i18n from "../i18n.js";
import {
  createToastMessage,
  setFavoritesChanged,
  setGlobalError,
  updateTalentFavoriteState,
} from "../store/";

export default function useTalentFavoriteAction({
  talent,
  onChange,
  onClick,
  visualOnly,
}) {
  const [sending, setSending] = useState(false);
  const dispatch = useDispatch();

  function showToastMessage(faved) {
    createToastMessage(dispatch, {
      type: faved ? "success" : "info",
      message: i18n.t(
        `toasts.success.talent_favorite_action.${faved ? "added" : "removed"}`
      ),
    });
    // Mark that the favorites page should be updated
    setTimeout(
      () => {
        dispatch(setFavoritesChanged(true));
      },
      faved ? 0 : 2000
    );
  }

  async function handleClick(event) {
    if (onClick) {
      return onClick(event);
    }
    // We do it here and not as a disabled state on button, since that would bubble click
    // through to the item which then does a redirect which we don't want.
    if (sending) {
      return;
    }
    tracking.track(`favorite.${talent.favorite ? "remove" : "add"}`, {
      talent_id: talent.id,
    });
    setSending(true);
    try {
      const change = await (talent.favorite
        ? talentsApi.removeFromFavorites(talent.id)
        : talentsApi.markAsFavorite(talent.id));
      dispatch(updateTalentFavoriteState(change));
      showToastMessage(change.favorite);

      onChange && onChange(change);
    } catch (err) {
      console.error(err);
      dispatch(setGlobalError(err.error));
    }
    setSending(false);
  }

  return {
    icon: !visualOnly && talent.favorite ? "favorite_filled" : "favorite_new",
    text: i18n.t(
      `component.talent_action.action.${
        talent.favorite ? "remove_from_favorite" : "add_to_favorite"
      }`
    ),
    onClick: handleClick,
  };
}
